import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { Breadcrumbs, H5 } from '../../AbstractElements';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeftCircle } from 'react-feather';
import axiosInstance from '../../interceptor/intercetptor-inctence';
import Loader from "../../Layout/Loader";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import dummyImg from "../../../src/assets/images/blank_image.png";
import { createAPI, createCashier, createSubAdmin } from './service/manage-staff-service';
import { Multiselect } from 'multiselect-react-dropdown';
import { useLoader } from '../../_helper/LoaderContext';
import { useClinicAdmin } from '../../_helper/ClinicProvider';
import LoadGoogleMapsAPI from '../LoadGoogleMapsAPI';
import PlacesAutocomplete from 'react-places-autocomplete';
import { secureApiRequest } from '../../Services/secureApiRequest';
import { decryptResponseData } from '../../Services/decryptApiResponse';
import errorImage from "../../assets/images/blank_image.png"
import { usePharmacy } from '../../_helper/PharmacyProvider';

const StaffAdd = () => {
    const [googleMapApiLoaded, setGoogleMapApiLoaded] = useState(false);
    const { clinicAdmin } = useClinicAdmin();
    const { pharmacyPOS } = usePharmacy();
    const { t } = useTranslation();
    const [formValues, setFormValues] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        phone: '',
        email: '',
        password: '',
        // dob: '',
        // gender: '',
        // role: '',
        // staffProfile: '',
        // designation: '',
        // address: '',
        // age: '',
        // imageFile: null,
    });
    const [formErrors, setFormErrors] = useState({});
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [address, setAddress] = useState(formValues.address);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [phoneCode, setPhoneCode] = useState('');
    const [fullPhone, setFullPhone] = useState('');
    const [togglePassword, setTogglePassword] = useState(false);
    const { setLoading } = useLoader();
    // State variables for image handling
    const [imageFile, setImageFile] = useState(null);
    const [imageSource, setImageSource] = useState(dummyImg);
    const history = useNavigate();

    // Get the current date in the format required by the date input element
    const getCurrentDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleInputChange = (eOrValue, fieldName = null) => {
        if (typeof eOrValue === "object" && eOrValue.target) {
            // Standard input field handling
            const { name, value } = eOrValue.target;
            const updatedValue = name === "lastName" ? value.toUpperCase() : value;
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: value,
                ...(name === 'dob' && { age: calculateAge(value) }), // Calculate age if 'dob' is updated
            }));

            setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        } else if (fieldName) {
            // Handle custom input like 'PlacesAutocomplete'
            if (fieldName === 'address') {
                setAddress(eOrValue); // Update address state
            }

            setFormValues((prevValues) => ({
                ...prevValues,
                [fieldName]: eOrValue,
            }));

            setFormErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
        }
    };

    const handleSelect = (selectedAddress) => {
        // Log the selected address
        console.log("Selected Address:", selectedAddress);
        // Update address state
        setAddress(selectedAddress);
        // Use geocoder to get latitude and longitude
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: selectedAddress }, (results, status) => {
            console.log("Geocoder Status:", status);

            if (status === 'OK') {
                const location = results[0].geometry.location;
                console.log("Geocoder Results:", results);
                console.log("Latitude:", location.lat());
                console.log("Longitude:", location.lng());
                setFormValues(prevValues => ({
                    ...prevValues,
                    address: selectedAddress,
                }));
                // Set latitude and longitude states
                setLatitude(location.lat());
                setLongitude(location.lng());
            } else {
                console.error('Geocode failed:', status);
            }
        });
    };

    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        // Adjust age if the birth month hasn't been reached yet this year
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    // Handle phone number change
    const handlePhoneChange = (value, country) => {
        const { dialCode } = country;
        if (value.startsWith(`${dialCode}`)) {
            const phoneNumber = value.slice(dialCode.length).trim();
            const countryCode = `+${dialCode}`
            setPhoneCode(countryCode)
            setFormValues({ ...formValues, phone: phoneNumber });
            setFormErrors({ ...formErrors, phone: "" });
            setFullPhone(`${countryCode}${phoneNumber}`)
        } else {
            const phoneNumber = value;
            const countryCode = `+${dialCode}`
            setPhoneCode(countryCode)
            setFormValues({ ...formValues, phone: phoneNumber });
            setFormErrors({ ...formErrors, phone: "" });
            setFullPhone(`${countryCode}${phoneNumber}`);
        }
    };

    // const handlePhoneChange = (value, country) => {
    //     const { dialCode } = country;
    //     const phoneNumber = value.replace('+'+country, '').trim();
    //     const countryCode = `+${dialCode}`
    //     console.log(countryCode)
    //     console.log(phoneNumber)
    //     setFormValues({ ...formValues, phoneCode: countryCode});
    //     setFormValues({ ...formValues, phone: phoneNumber });
    //     setFormErrors({ ...formErrors, phone: "" });
    // };

    // Function to handle image changes
    const handleImageChange = (e) => {
        console.log('handleImageChange called');
        if (e.target.files.length > 0) {
            const file = e.target.files[0];
            // console.log('File selected:', file);
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/tiff', 'image/bpg', 'image/bmp', 'image/heic', 'image/heif'];

            // Check if the selected file type is allowed
            if (allowedTypes.includes(file.type)) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    setImageSource(e.target.result); // Set the image source to the selected image
                    // console.log('Image source updated:', e.target.result);
                };
                reader.readAsDataURL(file);
                setImageFile(file);
                // console.log('File set:', file);
            } else {
                // Show an error toast message if the file type is not allowed
                toast.warning("File type is not allowed. Only png, jpg, jpeg, tiff, bpg, bmp, heic, and heif files are allowed.");

                // Reset the image file and image source to the default image
                setImageSource(dummyImg);
                setImageFile(null);

                // Clear the file input
                e.target.value = ""; // Set the file input value to an empty string to remove the chosen file

                console.log('File type not allowed');
            }
        }
    };

    const [profiles, setProfiles] = useState([]);

    // useEffect(() => {
    //     getProfileMaster();
    // }, []);

    // Profile Master
    const getProfileMaster = async () => {
        try {
            // const response = await axiosInstance.get(`masters/clinicuser-profiles/${clinicAdmin._id}`);
            const response = await secureApiRequest("get", `masters/clinicuser-profiles/${clinicAdmin._id}`);
            const dec_data = decryptResponseData(response);
            if (dec_data.status === 'success') {
                setProfiles(dec_data.data.privileges_profiles);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormSubmitted(true);
        const errors = {};

        // Validation for required fields
        if (!formValues.firstName.trim()) {
            errors.firstName = t("First Name is required.");
        }
        // if (!formValues.middleName.trim()) {
        //     errors.middleName = "Middle Name is required.";
        // }
        if (!formValues.lastName.trim()) {
            errors.lastName = t("Last Name is required.");
        }
        if (!formValues.phone) {
            errors.phone = t("Phone Number is required.");
        }
        if (!formValues.email.trim()) {
            errors.email = t("Email is required.");
        }
        if (!formValues.password.trim()) {
            errors.password = "Password is required.";
        }
        // if (!formValues.dob.trim()) {
        //     errors.dob = t("Date of Birth is required.");
        // }
        // if (new Date(formValues.dob) > new Date()) {
        //     errors.dob = t("Date of Birth cannot be in the future.");
        // }
        // if (!formValues.age) {
        //     errors.age = t("Age is required.");
        // }
        // if (!formValues.gender) {
        //     errors.gender = t("Gender is required.");
        // }
        // if (!formValues.role) {
        //     errors.role = t("Role is required.");
        // }
        // if (!formValues.staffProfile) {
        //     errors.staffProfile = t("Role is required.");
        // }
        // if (!formValues.designation.trim()) {
        //     errors.designation = t("Designation is required.");
        // }
        // if (!formValues.address) {
        //     errors.address = t("Address is required.");
        // }
        setFormErrors(errors);
        // If there are no errors, proceed with form submission logic
        if (Object.keys(errors).length === 0) {
            // console.log("Form submitted:", formValues);
            // const fd = new FormData();
            // // fd.append('role', formValues.role)
            // fd.append('role', formValues.staffProfile)
            // fd.append('first_name', formValues.firstName);
            // fd.append('middle_name', formValues.middleName);
            // fd.append('last_name', formValues.lastName);
            // fd.append('email', formValues.email);
            // fd.append('phone_code', phoneCode);
            // fd.append('mobile', formValues.phone);
            // fd.append('age', formValues.age);
            // fd.append('gender', formValues.gender);
            // fd.append('country_code', phoneCode);
            // fd.append('dob', formValues.dob);
            // // fd.append('privileges_profile_id', formValues.staffProfile);
            // // fd.append('designation', formValues.designation);
            // fd.append('address', formValues.address);
            // if (latitude !== null && longitude !== null) {
            //     fd.append("lat", latitude);
            //     fd.append("lng", longitude);
            // }
            // if (imageFile) {
            //     fd.append('picture', imageFile, imageFile.name);
            // } else {
            //     fd.append('picture', "");
            // }

            const formData = new FormData();

            /* Contact person */
            formData.append("contact_person[first_name]", formValues.firstName);
            formData.append("contact_person[last_name]", formValues.lastName);
            formData.append("contact_person[contact_email]", formValues.email.toLowerCase());
            formData.append("contact_person[mobile]", formValues.phone);
            formData.append("contact_person[phone_code]", phoneCode);
            formData.append("contact_person[address]", formValues.address);

            /* Main fields */
            formData.append("email", formValues.email.toLowerCase());
            formData.append("facility_name", pharmacyPOS?.facility_name);
            formData.append("password", formValues.password);

            /* Profile picture */
            if (imageFile) {
                formData.append("profile_picture", imageFile); // ✅ REQUIRED KEY
            }

            // if (latitude !== null && longitude !== null) {
            //     requestBody.lat = latitude;
            //     requestBody.lng = longitude;
            // }
            // const file = [];
            // if (imageFile) {
            //     file.push(imageFile)
            // }

            // console.log(requestBody);

            try {
                setLoading(true);
                // const response = await createAPI(fd)
                // const response = await createAPI(requestBody, file);
                const response = await createSubAdmin(formData);
                // const dec_data = decryptResponseData(response);
                if (response.data.status === 'success') {
                    setLoading(false);
                    toast.success(response.data.message);
                    history(`${process.env.PUBLIC_URL}/manage-staffs/list`);
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        }
    };

    const List = () => {
        history(`${process.env.PUBLIC_URL}/manage-staffs/list`);
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle={t('Add A Staff')} parent={t('Dashboard')} title={t('Add A Staff')} />
            <Col sm="12">
                <Card>
                    <CardHeader className="d-flex justify-content-between align-items-center">
                        <H5>{t('Add')}</H5>
                        <button
                            className="btn btn-primary d-flex align-items-center"
                            style={{ color: 'white', height: "40px" }}
                            to=""
                            onClick={List}>
                            <ArrowLeftCircle className="me-2" /> {t("Back")}
                        </button>
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {/* First Name Field */}
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("First Name")} <span className="text-danger">*</span></label>
                                        <input
                                            name="firstName"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Enter First Name")}
                                            value={formValues.firstName}
                                            onChange={handleInputChange}
                                            required=""
                                        />
                                        {formSubmitted && formErrors.firstName && <div className="text-danger"><small>{formErrors.firstName}</small></div>}
                                    </div>
                                </div>
                                {/* Middle Name Field */}
                                {/* <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Middle Name")}</label>
                                        <input
                                            name="middleName"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Enter Middle Name")}
                                            value={formValues.middleName}
                                            onChange={handleInputChange}
                                        // required=""
                                        />
                                        {formSubmitted && formErrors.middleName && <div className="text-danger"><small>{formErrors.middleName}</small></div>}
                                    </div>
                                </div> */}

                                {/* Last Name Field */}
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Last Name")} <span className="text-danger">*</span></label>
                                        <input
                                            name="lastName"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Enter Last Name")}
                                            value={formValues.lastName}
                                            onChange={handleInputChange}
                                            required=""
                                        />
                                        {formSubmitted && formErrors.lastName && <div className="text-danger"><small>{formErrors.lastName}</small></div>}
                                    </div>
                                </div>

                                {/* Phone Number Field */}
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Phone Number")} <span className="text-danger">*</span></label>
                                        <PhoneInput
                                            country="in"
                                            value={fullPhone}
                                            onChange={handlePhoneChange}
                                            containerClassName="phone-input-contained"
                                            enableSearch
                                            searchPlaceholder={t("Search your country")}
                                            searchNotFound="Country not found"
                                            required=""
                                        />
                                        {formSubmitted && formErrors.phone && <div className="text-danger"><small>{formErrors.phone}</small></div>}
                                    </div>
                                </div>

                                {/* Email Field */}
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Email")} <span className="text-danger">*</span></label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder={t("Enter Email")}
                                            name="email"
                                            value={formValues.email}
                                            onChange={handleInputChange}
                                            required=""
                                            autoComplete="new-email"
                                        />
                                        {formSubmitted && formErrors.email && <div className="text-danger"><small>{formErrors.email}</small></div>}
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Address")} <span className="text-danger">*</span></label>
                                        {/* <input
                                            type="text"
                                            name="address"
                                            value={formValues.address}
                                            onChange={(value) => handleInputChange(value, 'address')}
                                            className="form-control form-control-lg"
                                            placeholder={t("Enter full address")}
                                        /> */}
                                        <LoadGoogleMapsAPI onLoad={() => setGoogleMapApiLoaded(true)} />

                                        {googleMapApiLoaded && (
                                            <PlacesAutocomplete
                                                value={formValues.address}
                                                onChange={(value) => handleInputChange(value, 'address')}
                                                onSelect={handleSelect}
                                            >
                                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                    <div>
                                                        <input
                                                            {...getInputProps({
                                                                className: "form-control input-font-size",
                                                                placeholder: "Enter Address",
                                                                id: "address",
                                                                name: "address",
                                                                type: "text",
                                                            })}
                                                        />
                                                        {loading && <div className="loading-indicator">Loading...</div>}
                                                        {suggestions.length > 0 && (
                                                            <div className="suggestions-list" style={{
                                                                border: "1px solid #ccc",
                                                                borderRadius: "4px",
                                                                maxHeight: "200px",
                                                                overflowY: "auto",
                                                                position: "absolute",
                                                                width: "100%",
                                                                zIndex: 100,
                                                            }}>
                                                                {suggestions.map((suggestion, index) => (
                                                                    <div
                                                                        key={index}
                                                                        {...getSuggestionItemProps(suggestion)}
                                                                        className="suggestion-item"
                                                                        style={{
                                                                            padding: "8px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        {suggestion.description}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </PlacesAutocomplete>
                                        )}
                                        {formSubmitted && formErrors.address && (
                                            <div className="text-danger" style={{ marginTop: "5px" }}>
                                                {formErrors.address}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Password */}
                                <div className="col-md-3">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Password")} <span className="text-danger">*</span></label>
                                        <div className="input-group">
                                            <input
                                                type={togglePassword ? "text" : "password"}
                                                className="form-control"
                                                placeholder={t("Enter Password")}
                                                name="password"
                                                value={formValues.password}
                                                onChange={handleInputChange}
                                                required=""
                                                autoComplete="new-password"
                                            />
                                            <span className="input-group-text" style={{ cursor: 'pointer' }}
                                                onClick={() => setTogglePassword(!togglePassword)}>
                                                <i className={`fa ${togglePassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
                                            </span>
                                        </div>
                                        {formSubmitted && formErrors.password && <div className="text-danger"><small>{formErrors.password}</small></div>}
                                    </div>
                                </div>
                                {/* Date of Birth Field */}
                                {/* <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Date of Birth")} <span className="text-danger">*</span></label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={formValues.dob}
                                            onChange={handleInputChange}
                                            name="dob"
                                            max={getCurrentDate()} // Setting max to current date to restrict future dates
                                            required=""
                                        />
                                        {formSubmitted && formErrors.dob && <div className="text-danger"><small>{formErrors.dob}</small></div>}
                                    </div>
                                </div> */}

                                {/* Age Field */}
                                {/* <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Age")} <span className="text-danger">*</span></label>
                                        <input
                                            type="number"
                                            min="0"
                                            className="form-control"
                                            placeholder={t("Enter Your Age")}
                                            value={formValues.age}
                                            onChange={handleInputChange}
                                            name="age"
                                            required=""
                                        />
                                        {formSubmitted && formErrors.age && <div className="text-danger"><small>{formErrors.age}</small></div>}
                                    </div>
                                </div> */}

                                {/* Profile Image Field */}
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">{t("Profile Image")} </label>
                                    <input className="form-control" type="file" onChange={handleImageChange} />

                                </div>

                                {/* Profile Image Preview */}
                                <div className="col-md-1">
                                    <img
                                        src={imageSource}
                                        style={{ objectFit: 'fill', borderRadius: "50px" }}
                                        height="75px"
                                        width="75px"
                                        alt="User Profile"
                                        onError={(e) => {
                                            e.target.src = errorImage;
                                        }}
                                    />
                                </div>

                                {/* Gender Field */}
                                {/* <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Gender")} <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select form-control"
                                            value={formValues.gender}
                                            onChange={handleInputChange}
                                            name="gender"
                                            required=""
                                        >
                                            <option value="">{t("Select")}</option>
                                            <option value="male">{t("Male")}</option>
                                            <option value="female">{t("Female")}</option>
                                            <option value="other">{t("Other")}</option>
                                        </select>
                                        {formSubmitted && formErrors.gender && <div className="text-danger"><small>{formErrors.gender}</small></div>}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Role")} <span className="text-danger">*</span>
                                        {profiles.length === 0 &&
                                            <small className="text-danger">{t("Please add a privilege profile first")}</small>
                                        }
                                        </label>
                                        <select
                                            className="form-select form-control"
                                            value={formValues.staffProfile}
                                            onChange={handleInputChange}
                                            name="staffProfile"
                                            required=""
                                        >
                                            <option value="" disabled>{t("Select")}</option>
                                            {profiles.map((item) => (
                                                <option key={item._id} value={item._id}>
                                                    {item.profile_name}
                                                </option>
                                            ))}
                                        </select>
                                        {formSubmitted && formErrors.staffProfile && <div className="text-danger"><small>{formErrors.staffProfile}</small></div>}
                                    </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Role")} <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select form-control"
                                            value={formValues.role}
                                            onChange={handleInputChange}
                                            name="role"
                                            required=""
                                        >
                                            <option value="">{t("Select")}</option>
                                            <option value="sub_admin">{t("Sub Admin")}</option>
                                            <option value="accountant">{t("Accountant")}</option>
                                            <option value="staff">{t("Staff")}</option>
                                            <option value="receptionist">{t("Receptionist")}</option>
                                            <option value="assistant">{t("Assistant")}</option>
                                        </select>
                                        {formSubmitted && formErrors.role && <div className="text-danger"><small>{formErrors.role}</small></div>}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <label className="form-label">{t("Designation")} <span className="text-danger">*</span></label>
                                        <input
                                            name="designation"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Enter Designation")}
                                            value={formValues.designation}
                                            onChange={handleInputChange}
                                            required=""
                                        />
                                        {formSubmitted && formErrors.designation && <div className="text-danger"><small>{formErrors.designation}</small></div>}
                                    </div>
                                </div> */}
                            </div>

                            {/* <div className="col-md-12 my-3">
                                <div className="table-responsive rounded">
                                    <Table className='table-center table-bordered mb-0 table-hover'>
                                        <thead>
                                            <tr>
                                                <th width="5%">#</th>
                                                <th width="30%">{t("Title")}</th>
                                                <th width="35%">{t("Institution Name")}</th>
                                                <th width="15%">{t("Year")}</th>
                                                <th width="15%">{t("Actions")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {qualifications.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t("Enter Title")}
                                                            name="title"
                                                            value={item.title}
                                                            onChange={(e) => handleQualificationChange(e, index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t("Enter Institution Name")}
                                                            name="institution_name"
                                                            value={item.institution_name}
                                                            onChange={(e) => handleQualificationChange(e, index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t("Enter Year")}
                                                            name="year"
                                                            value={item.year}
                                                            onChange={(e) => handleQualificationChange(e, index)}
                                                        />
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className="actions">
                                                            <button
                                                                type='button'
                                                                id={`AddToolTip-${index}`}
                                                                onClick={addQualificationRow}
                                                                className="success-action-button"
                                                            >
                                                                <i className="fa fa-plus-circle" style={{ fontSize: "18px" }}></i>
                                                            </button>
                                                            <ToolTip
                                                                attrToolTip={{
                                                                    placement: 'top',
                                                                    isOpen: tooltipOpen[index].add,
                                                                    target: `AddToolTip-${index}`,
                                                                    toggle: () => toggleTooltip(index, 'add'),
                                                                }}
                                                            >
                                                                <strong>{t("Add")}</strong>
                                                            </ToolTip>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                                            <button
                                                                type='button'
                                                                id={`DeleteToolTip-${index}`}
                                                                onClick={() => deleteQualificationRow(index)}
                                                                className="danger-action-button"
                                                            >
                                                                <i className="fa fa-trash" aria-hidden="true" style={{ fontSize: "18px" }}></i>
                                                            </button>
                                                            <ToolTip
                                                                attrToolTip={{
                                                                    placement: 'top',
                                                                    isOpen: tooltipOpen[index].delete,
                                                                    target: `DeleteToolTip-${index}`,
                                                                    toggle: () => toggleTooltip(index, 'delete'),
                                                                }}
                                                            >
                                                                <strong>{t("Remove")}</strong>
                                                            </ToolTip>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div> */}


                            {/* Form submission buttons */}
                            <div className="row" style={{ justifyContent: 'end' }}>
                                <div className="col-md-2">
                                    <button
                                        className="btn btn-primary align-items-center w-100 mb-3"
                                        style={{ color: 'white', height: "40px" }}>
                                        {t("Add")}
                                    </button>
                                </div>
                                <div className="col-md-2">
                                    <button
                                        className="btn btn-secondary align-items-center w-100 mb-3"
                                        style={{ color: 'white', height: "40px" }}
                                        to=""
                                        onClick={List}>
                                        {t("Cancel")}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
};

export default StaffAdd;
